import { ROUTER_PATH, ROUTER_TITLES } from '@/router/constants';
import EventPage from '@/pages/customer-support/event/EventPage';
import FaqPage from '@/pages/customer-support/faq/FaqPage';
import NoticePage from '@/pages/customer-support/notice/NoticePage';
import NoticeDetailPage from '@/pages/customer-support/notice/NoticeDetailPage';
import EventDetailPage from '@/pages/customer-support/event/EventDetailPage';
import FaqDetailPage from '@/pages/customer-support/faq/FaqDetailPage';

export const CustomerSupportRouter = {
	title: ROUTER_TITLES.CUSTOMER_SUPPORT.EVENT,
	children: [
		{
			path: ROUTER_PATH.CUSTOMER_SUPPORT.EVENT,
			element: <EventPage />,
			title: ROUTER_TITLES.CUSTOMER_SUPPORT.EVENT
		},
		{
			path: ROUTER_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL,
			element: <EventDetailPage />,
			title: ROUTER_TITLES.CUSTOMER_SUPPORT.EVENT
		},
		{
			path: ROUTER_PATH.CUSTOMER_SUPPORT.FAQ,
			element: <FaqPage />,
			title: ROUTER_TITLES.CUSTOMER_SUPPORT.FAQ
		},
		{
			path: ROUTER_PATH.CUSTOMER_SUPPORT.FAQ_DETAIL,
			element: <FaqDetailPage />,
			title: ROUTER_TITLES.CUSTOMER_SUPPORT.FAQ
		},
		{
			path: ROUTER_PATH.CUSTOMER_SUPPORT.NOTICE,
			element: <NoticePage />,
			title: ROUTER_TITLES.CUSTOMER_SUPPORT.NOTICE
		},
		{
			path: ROUTER_PATH.CUSTOMER_SUPPORT.NOTICE_DETAIL,
			element: <NoticeDetailPage />,
			title: ROUTER_TITLES.CUSTOMER_SUPPORT.NOTICE
		}
	]
};
